import { createSelector } from "reselect";
import type { Reconciliation } from "src/interfaces/reconciliation.interface";

import type { AppState } from "../..";
import { generalLedgerAccountsSelector } from "../../glAccounts/selector";
import { integrationsSelector } from "../../plaidIntegration/selector";

import { BankAccountState } from "../reducers";

const getBankAccountState = (state: AppState) => state.bankAccount;
const bankAccountsItemsSelector = createSelector(
  [getBankAccountState],
  (state: BankAccountState) => state.items
);

export const bankAccountsSelector = createSelector(
  [
    bankAccountsItemsSelector,
    generalLedgerAccountsSelector,
    integrationsSelector,
  ],
  (items, glAccounts, integrations) => {
    return items.map((item) => {
      return {
        ...item,
        reconciliations: [] as Reconciliation[],
        generalLedgerAccount: glAccounts.find(
          (a) => a.id === item.general_ledger_account_id
        ),
        integration: item.integration_id
          ? integrations.find((a) => a.id === item.integration_id)
          : undefined,
      };
    });
  }
);

export const bankAccountByIdSelector = createSelector(
  [bankAccountsSelector, (_, id) => id],
  (bankAccounts, id) => {
    return bankAccounts.find((b) => b.id === id);
  }
);

export const bankAccountByIntegrationIdSelector = createSelector(
  [bankAccountsSelector, (_, id) => id],
  (bankAccounts, id) => {
    return bankAccounts.find((b) => b.integration_id === id);
  }
);

export const nonAssociatedIntegrationsSelector = createSelector(
  [integrationsSelector, bankAccountsItemsSelector],
  (integrations, bankAccounts) => {
    return integrations.filter(
      (integration) =>
        !bankAccounts.find(
          (bankAccount) => bankAccount.integration_id === integration.id
        )
    );
  }
);

export const bankAccountsWithOutIntegrationSelector = createSelector(
  [bankAccountsSelector],
  (bankAccounts) => {
    return bankAccounts.filter((ba) => !ba.integration);
  }
);
